import { useState } from "react";
import OtpInput from "react-otp-input";

interface OTPInputProps {
  length?: number;
  onChangeOTP?: (otp: string) => void;
}

export default function OTPInput({ length = 6, onChangeOTP }: OTPInputProps) {
  const [otp, setOtp] = useState("");

  const handleChange = (value: string) => {
    setOtp(value);
    if (onChangeOTP) {
      onChangeOTP(value);
    }
  };

  const inputStyles:any = {
    fontSize: "2.2em",
    fontWeight: "bold",
    height: "auto ",
    maxWidth: "42px ",
    maxHeight: "42px ",
    marginRight: "10px",
    borderRadius: "4px",
    border: "1px solid #D0D2DD",
    textAlign: 'center'
  };

  return (
    <OtpInput
      value={otp}
      onChange={handleChange}
      numInputs={length}
      renderInput={(props) => <input {...props} />}
      inputStyle={inputStyles}
      shouldAutoFocus
      skipDefaultStyles
    />
  );
}
